import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export const twCn = (...inputs: ClassValue[]) => {
  return twMerge(clsx(inputs));
};
